import type {
  Campaign,
  Dispatch,
  CreateCampaignPayload,
  UpdateCampaignPayload,
} from "../types";
import { isBulkNotificationsMock } from "../config";
import {
  mockCampaigns,
  mockDispatchesByCampaign,
  getMockCampaigns,
  getMockDispatches,
} from "./mockData";

function notImplemented(): never {
  throw new Error("Backend de notificações em massa ainda não disponível.");
}

export const bulkNotificationsApi = {
  campaigns: {
    list: async (): Promise<Campaign[]> => {
      if (isBulkNotificationsMock) return getMockCampaigns();
      return [];
    },
    get: async (id: string): Promise<Campaign | null> => {
      if (isBulkNotificationsMock) {
        return mockCampaigns.find((c) => c.id === id) ?? null;
      }
      return null;
    },
    create: async (payload: CreateCampaignPayload): Promise<Campaign> => {
      if (isBulkNotificationsMock) {
        const now = new Date().toISOString();
        const campaign: Campaign = {
          id: `mock-campaign-${Date.now()}`,
          title: payload.title,
          channel: payload.channel,
          status: payload.scheduledAt ? "scheduled" : "draft",
          scheduledAt: payload.scheduledAt,
          recipientCount: payload.recipientOption === "all" ? 999 : 0,
          subject: payload.subject ?? null,
          body: payload.body ?? null,
          recipientOption: payload.recipientOption,
          createdAt: now,
          updatedAt: now,
        };
        mockCampaigns.push(campaign);
        return campaign;
      }
      notImplemented();
    },
    update: async (
      id: string,
      payload: UpdateCampaignPayload
    ): Promise<Campaign> => {
      if (isBulkNotificationsMock) {
        const idx = mockCampaigns.findIndex((c) => c.id === id);
        if (idx === -1) throw new Error("Campanha não encontrada");
        const now = new Date().toISOString();
        mockCampaigns[idx] = {
          ...mockCampaigns[idx],
          ...payload,
          updatedAt: now,
        };
        return mockCampaigns[idx];
      }
      notImplemented();
    },
  },
  dispatches: {
    list: async (campaignId: string): Promise<Dispatch[]> => {
      if (isBulkNotificationsMock) return getMockDispatches(campaignId);
      return [];
    },
  },
};
